module.exports = "https://static.zego.com/_next/static/images/ES-1ed0b5b35617477b79b841b441e29254.png";